
import { isFeatureEnabled } from "@/utils/featureFlags";
import { Users, Mail } from "lucide-react";

const FeaturesGrid = () => {
  return (
    <div className="w-full max-w-2xl mx-auto mt-4 mb-8 grid grid-cols-1 md:grid-cols-2 gap-3">
      {isFeatureEnabled('CONTACT_BOOKING') && (
        <div className="p-3 rounded-xl border border-border shadow-sm hover:shadow-md transition-shadow bg-card">
          <div className="flex items-center justify-center gap-2 mb-1.5">
            <Users 
              className="h-4 w-4 text-green-500"
            />
            <h3 className="text-xs font-semibold text-card-foreground">Contact Smart Scheduling</h3>
          </div>
          <p className="text-xs text-muted-foreground text-center">
            Schedule meetings with people in your contact list
          </p>
        </div>
      )}

      {isFeatureEnabled('EMAIL_BOOKING') && (
        <div className="p-3 rounded-xl border border-border shadow-sm hover:shadow-md transition-shadow bg-card/50 backdrop-blur-sm">
          <div className="flex items-center justify-center gap-2 mb-1.5">
            <Mail 
              className="h-4 w-4 text-blue-500"
            />
            <h3 className="text-xs font-semibold text-card-foreground">Upcoming Releases</h3>
          </div>
          <p className="text-xs text-muted-foreground text-center">
            Book meetings with anyone you've emailed
          </p>
        </div>
      )}
    </div>
  );
};

export default FeaturesGrid;
